export default class ProfileProperties {
  name?: string;
}
